<template>
  <div class="mods-wl">
    <div class="mods-wl__card">
      <div class="mods-wl__head">
        <div>
          <div class="mods-wl__title">Белый список</div>
          <div class="mods-wl__subtitle">
            На эти домофоны, калитки и доп. входы не загружается рекламное аудио
            открытия двери и ежемесячные показания счётчиков
          </div>
        </div>
        <v-btn
          rounded
          elevation="0"
          class="text-none mods-wl__add-btn"
          @click="openAdd"
        >
          <v-icon left small>mdi-shield-plus-outline</v-icon>
          Добавить
        </v-btn>
      </div>

      <div class="mods-wl__toolbar">
        <v-text-field
          v-model="search"
          label="Поиск по ID или адресу"
          outlined
          dense
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          class="mods-wl__search"
          @keyup.enter="onSearch"
          @click:clear="onSearch"
        />
        <v-select
          v-model="type"
          :items="typeItems"
          item-text="text"
          item-value="value"
          label="Тип"
          outlined
          dense
          hide-details
          clearable
          class="mods-wl__type"
        />
        <v-btn
          color="primary"
          class="text-none"
          rounded
          elevation="0"
          :loading="loading"
          @click="onSearch"
        >
          Найти
        </v-btn>
        <v-spacer />
        <span class="mods-wl__count">{{ total }} в списке</span>
      </div>

      <v-data-table
        class="table mods-list"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        item-key="id"
        disable-sort
        hide-default-footer
      >
        <template v-slot:item.doorphone_id="{ item }">
          <span class="mods-list__id">{{ item.doorphone_id }}</span>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip x-small label :color="typeColor(item.type)" :text-color="typeTextColor(item.type)">
            {{ typeLabel(item.type) }}
          </v-chip>
        </template>
        <template v-slot:item.model="{ item }">
          <v-chip x-small label color="blue-grey lighten-5" text-color="blue-grey darken-2">
            {{ item.model || '—' }}
          </v-chip>
        </template>
        <template v-slot:item.comment="{ item }">
          <span class="mods-wl__comment">{{ item.comment || '—' }}</span>
        </template>
        <template v-slot:item.created_at="{ item }">
          <div>{{ formatDate(item.created_at) }}</div>
          <div class="mods-wl__user">{{ item.user_name || '—' }}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small :aria-label="'Изменить комментарий ' + item.doorphone_id" @click="openEdit(item)">
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn icon small color="error" :aria-label="'Удалить ' + item.doorphone_id" @click="askRemove(item)">
            <v-icon small>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <div class="py-8 text-center grey--text">
            <v-icon large color="grey lighten-1" class="mb-2">mdi-shield-check-outline</v-icon>
            <div>Белый список пуст</div>
          </div>
        </template>
      </v-data-table>

      <div class="mods-wl__pager">
        <span class="mods-wl__pager-label">Строк</span>
        <v-select
          :value="options.itemsPerPage"
          :items="pageSizeOptions"
          dense
          hide-details
          outlined
          class="mods-wl__pager-select"
          @change="setItemsPerPage"
        />
        <span class="mods-wl__range">{{ pageRangeText }}</span>
        <v-btn icon x-small :disabled="options.page <= 1 || loading" @click="setPage(1)">
          <v-icon small>mdi-page-first</v-icon>
        </v-btn>
        <v-btn icon x-small :disabled="options.page <= 1 || loading" @click="setPage(options.page - 1)">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon x-small :disabled="options.page >= pageCount || loading" @click="setPage(options.page + 1)">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn icon x-small :disabled="options.page >= pageCount || loading" @click="setPage(pageCount)">
          <v-icon small>mdi-page-last</v-icon>
        </v-btn>
      </div>
    </div>

    <mass-open-door-sound-whitelist-add-dialog
      v-model="addDialog"
      :saving="saving"
      @submit="submitAdd"
    />

    <v-dialog
      v-model="editDialog"
      max-width="560"
      persistent
      content-class="wl-edit-dialog"
    >
      <v-card v-if="editItem" class="wl-edit">
        <div class="wl-edit__hero">
          <div class="wl-edit__hero-main">
            <div class="wl-edit__hero-icon">
              <v-icon color="white">mdi-comment-edit-outline</v-icon>
            </div>
            <div>
              <div class="wl-edit__hero-title">Комментарий</div>
              <div class="wl-edit__hero-text">Можно изменить только заметку — устройство из списка не уйдёт</div>
            </div>
          </div>
          <v-btn
            icon
            class="wl-edit__close"
            aria-label="Закрыть"
            :disabled="saving"
            @click="closeEdit"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="wl-edit__body">
          <div class="wl-edit__device">
            <div class="wl-edit__device-row">
              <span class="wl-edit__id">#{{ editItem.doorphone_id }}</span>
              <v-chip
                x-small
                label
                :color="typeColor(editItem.type)"
                :text-color="typeTextColor(editItem.type)"
              >
                {{ typeLabel(editItem.type) }}
              </v-chip>
              <v-chip
                v-if="editItem.model"
                x-small
                label
                color="blue-grey lighten-5"
                text-color="blue-grey darken-2"
              >
                {{ editItem.model }}
              </v-chip>
            </div>
            <div class="wl-edit__address">
              <v-icon x-small color="primary" class="mr-1">mdi-map-marker-outline</v-icon>
              {{ editItem.address || 'Адрес не указан' }}
            </div>
          </div>

          <v-textarea
            ref="editCommentField"
            v-model="editComment"
            label="Комментарий"
            placeholder="Зачем устройство в белом списке"
            outlined
            rows="4"
            auto-grow
            counter="500"
            maxlength="500"
            hide-details="auto"
            @keydown.ctrl.enter="submitEdit"
          />
        </v-card-text>

        <v-card-actions class="wl-edit__footer">
          <v-btn
            rounded
            outlined
            color="primary"
            class="text-none"
            :disabled="saving"
            @click="closeEdit"
          >
            Отмена
          </v-btn>
          <v-btn
            rounded
            elevation="0"
            class="text-none wl-edit__save"
            :loading="saving"
            :disabled="!commentChanged"
            @click="submitEdit"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeDialog" max-width="460">
      <v-card>
        <v-card-title class="text-h6">Удалить из списка?</v-card-title>
        <v-card-text v-if="removeItem">
          Устройство #{{ removeItem.doorphone_id }} снова сможет получать рекламное аудио
          и показания счётчиков.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text class="text-none" @click="removeDialog = false">Отмена</v-btn>
          <v-btn color="error" class="text-none" :loading="saving" @click="submitRemove">
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DoorphoneApi from '@/services/api/doorphone';
import MassOpenDoorSoundWhitelistAddDialog from '@/components/massOpenDoorSound/MassOpenDoorSoundWhitelistAddDialog.vue';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

const PAGE_SIZE_OPTIONS = [20, 50, 100];
const TYPE_ITEMS = [
  { value: 'M', text: 'Домофон' },
  { value: 'G', text: 'Калитка' },
  { value: 'A', text: 'Доп. вход' },
];

export default {
  name: 'MassOpenDoorSoundWhitelist',
  mixins: [ruDateFormatMixin],
  components: {
    MassOpenDoorSoundWhitelistAddDialog,
  },
  data () {
    return {
      search: '',
      type: null,
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      suppressOptionsWatch: false,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
      typeItems: TYPE_ITEMS,
      headers: [
        { text: 'ID', value: 'doorphone_id', width: 80 },
        { text: 'Тип', value: 'type', width: 120 },
        { text: 'Адрес', value: 'address' },
        { text: 'Модель', value: 'model', width: 140 },
        { text: 'Комментарий', value: 'comment' },
        { text: 'Добавлен', value: 'created_at', width: 220 },
        { text: '', value: 'actions', width: 96, sortable: false },
      ],
      addDialog: false,
      editDialog: false,
      removeDialog: false,
      saving: false,
      editItem: null,
      editComment: '',
      removeItem: null,
    };
  },
  computed: {
    pageCount () {
      const perPage = Number(this.options.itemsPerPage) || 20;
      return Math.max(1, Math.ceil((this.total || 0) / perPage));
    },
    pageRangeText () {
      if (!this.total) return '0 из 0';
      const perPage = Number(this.options.itemsPerPage) || 20;
      const from = (this.options.page - 1) * perPage + 1;
      const to = Math.min(this.total, this.options.page * perPage);
      return `${from}–${to} из ${this.total}`;
    },
    commentChanged () {
      const next = String(this.editComment || '').trim();
      const prev = String((this.editItem && this.editItem.comment) || '').trim();
      return next !== prev;
    },
  },
  watch: {
    'options.page' () {
      if (this.suppressOptionsWatch) return;
      this.loadItems();
    },
    type (value, oldValue) {
      if ((value || null) === (oldValue || null)) return;
      this.onSearch();
    },
  },
  created () {
    this.loadItems();
  },
  methods: {
    typeLabel (type) {
      if (type === 'G') return 'Калитка';
      if (type === 'A') return 'Доп. вход';
      return 'Домофон';
    },
    typeColor (type) {
      if (type === 'G') return 'teal lighten-5';
      if (type === 'A') return 'deep-purple lighten-5';
      return 'blue lighten-5';
    },
    typeTextColor (type) {
      if (type === 'G') return 'teal darken-3';
      if (type === 'A') return 'deep-purple darken-3';
      return 'primary';
    },
    formatDate (value) {
      if (!value) return '—';
      const formatted = this.ruDateFormat(value);
      return formatted && formatted !== 'Invalid Date' ? formatted : '—';
    },
    refresh () {
      return this.loadItems();
    },
    onSearch () {
      if (this.options.page !== 1) {
        this.options.page = 1;
        return;
      }
      this.loadItems();
    },
    setPage (page) {
      this.options.page = page;
    },
    setItemsPerPage (value) {
      this.suppressOptionsWatch = true;
      this.options.itemsPerPage = Number(value) || 20;
      this.options.page = 1;
      this.$nextTick(() => {
        this.suppressOptionsWatch = false;
        this.loadItems();
      });
    },
    loadItems () {
      this.loading = true;
      return DoorphoneApi.getOpenDoorSoundWhitelist({
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: {
          search: this.search,
          type: this.type,
        },
      })
        .then(({ data }) => {
          this.items = data.items || [];
          this.total = data.meta?.total || 0;
        })
        .catch(() => {
          this.$flash_warning('Не удалось загрузить белый список');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAdd () {
      this.addDialog = true;
    },
    submitAdd ({ doorphoneIds, comment }) {
      if (!doorphoneIds || !doorphoneIds.length) return;
      this.saving = true;
      DoorphoneApi.storeOpenDoorSoundWhitelist({
        doorphoneIds,
        comment: comment || null,
      })
        .then(({ data }) => {
          const added = (data.added || []).length;
          const skipped = (data.skipped || []).length;
          if (skipped && added) {
            this.$flash_success(`Добавлено: ${added}. Уже были в списке: ${skipped}`);
          } else if (added) {
            this.$flash_success(added > 1 ? `Добавлено устройств: ${added}` : 'Устройство добавлено в белый список');
          }
          this.addDialog = false;
          this.loadItems();
          this.$emit('changed');
        })
        .catch((e) => {
          const errors = e?.response?.data?.errors;
          const firstError = errors && Object.values(errors).flat()[0];
          const message = firstError || e?.response?.data?.message || e?.response?.data?.error || 'Не удалось добавить в белый список';
          this.$flash_warning(message);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    openEdit (item) {
      this.editItem = item;
      this.editComment = item.comment || '';
      this.editDialog = true;
      this.$nextTick(() => {
        const field = this.$refs.editCommentField;
        if (field && field.focus) field.focus();
      });
    },
    closeEdit () {
      if (this.saving) return;
      this.editDialog = false;
      this.editItem = null;
      this.editComment = '';
    },
    submitEdit () {
      if (!this.editItem || !this.commentChanged || this.saving) return;
      this.saving = true;
      DoorphoneApi.updateOpenDoorSoundWhitelist(this.editItem.id, {
        comment: this.editComment,
      })
        .then(() => {
          this.saving = false;
          this.$flash_success('Комментарий сохранён');
          this.closeEdit();
          this.loadItems();
        })
        .catch((e) => {
          const message = e?.response?.data?.message || 'Не удалось сохранить комментарий';
          this.$flash_warning(message);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    askRemove (item) {
      this.removeItem = item;
      this.removeDialog = true;
    },
    submitRemove () {
      if (!this.removeItem) return;
      this.saving = true;
      DoorphoneApi.destroyOpenDoorSoundWhitelist(this.removeItem.id)
        .then(() => {
          this.$flash_success('Устройство убрано из белого списка');
          this.removeDialog = false;
          this.loadItems();
          this.$emit('changed');
        })
        .catch((e) => {
          const message = e?.response?.data?.message || 'Не удалось удалить из списка';
          this.$flash_warning(message);
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.mods-wl__card {
  background: #fff;
  border: 1px solid #e3eaf3;
  border-radius: 14px;
  padding: 16px 16px 12px;
  box-shadow: 0 2px 10px rgba(13, 64, 146, 0.04);
  min-height: 560px;
}
.mods-wl__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.mods-wl__title {
  font-size: 1.1rem;
  font-weight: 650;
  color: #263238;
}
.mods-wl__add-btn {
  color: #fff !important;
  background: linear-gradient(135deg, #0d4092 0%, #1e88e5 100%) !important;
  box-shadow: 0 6px 16px rgba(13, 64, 146, 0.28) !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}
.mods-wl__subtitle {
  font-size: 0.82rem;
  color: #78909c;
  max-width: 640px;
  margin-top: 4px;
}
.mods-wl__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.mods-wl__search {
  max-width: 320px;
  flex: 1 1 240px;
}
.mods-wl__type {
  max-width: 180px;
  width: 180px;
}
.mods-wl__count {
  font-size: 0.8rem;
  color: #90a4ae;
}
.mods-wl__comment {
  color: #546e7a;
}
.mods-wl__user {
  font-size: 0.72rem;
  color: #90a4ae;
}
.mods-list__id {
  font-family: monospace;
  font-size: 0.85rem;
  color: #546e7a;
}
.mods-wl__pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
.mods-wl__pager-label,
.mods-wl__range {
  font-size: 0.78rem;
  color: #90a4ae;
}
.mods-wl__pager-select {
  max-width: 88px;
}
.wl-edit {
  overflow: hidden;
  border-radius: 16px;
}
.wl-edit__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 16px;
  color: #fff;
  background: linear-gradient(135deg, #0d4092 0%, #1e88e5 100%);
}
.wl-edit__hero-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}
.wl-edit__hero-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.wl-edit__hero-title {
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.25;
}
.wl-edit__hero-text {
  margin-top: 3px;
  font-size: 0.76rem;
  color: rgba(255, 255, 255, 0.82);
}
.wl-edit__close {
  background: rgba(255, 255, 255, 0.14) !important;
  flex-shrink: 0;
}
.wl-edit__body {
  background: linear-gradient(180deg, #f3f7fc 0%, #fff 80px);
  padding: 16px 18px 8px;
}
.wl-edit__device {
  background: #fff;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 16px;
  box-shadow: 0 2px 10px rgba(13, 64, 146, 0.05);
}
.wl-edit__device-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.wl-edit__id {
  font-family: monospace;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0d4092;
}
.wl-edit__address {
  display: flex;
  align-items: flex-start;
  color: #546e7a;
  font-size: 0.85rem;
  line-height: 1.35;
}
.wl-edit__footer {
  padding: 8px 18px 16px;
  justify-content: flex-end;
  gap: 8px;
}
.wl-edit__save {
  color: #fff !important;
  background: linear-gradient(135deg, #0d4092 0%, #1e88e5 100%) !important;
  box-shadow: 0 6px 16px rgba(13, 64, 146, 0.28) !important;
  font-weight: 600 !important;
}
.wl-edit__save ::v-deep .v-btn__content,
.wl-edit__save.v-btn--disabled ::v-deep .v-btn__content {
  color: #fff !important;
}
</style>

<style>
.wl-edit-dialog {
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: 0 18px 48px rgba(13, 64, 146, 0.22) !important;
}
</style>
